<template>
    <div class="policy_content">
        <b>用户服务协议</b>
        <br/>
        <br/>
        特别提示：<br/>
        欢迎您使用由长光卫星技术股份有限公司自主运营的吉林一号生态开放商城！<br/>
        在使用吉林一号生态开放商城（以下简称“本网站”）提供的各项服务之前，请您务必审慎阅读、充分理解《吉林一号生态开放商城用户服务协议》和《吉林一号生态开放商城隐私政策》的各条款内容。如您不同意本协议或其中任何条款的约定，您可以主动停止使用本商城提供的服务；您一旦使用本商城提供的服务，即视为您已了解并完全同意本协议的各项内容，包括本商城对服务协议随时所做的任何修改，并成为吉林一号生态开放商城用户。若您是18周岁以下的未成年人，在使用我们的服务前，应在您的监护人的监护、指导并获得监护人同意的情况下，认真阅读并同意本协议。<br/>
        <b>一、服务条款的确认及接受</b><br/>
        1.1 吉林一号生态开放商城（JL1.mall，以下简称“本网站”）是由长光卫星技术股份有限公司基于互联网运营的向您提供各项服务的网络平台。<br/>
        1.2 本协议由您与长光卫星技术股份有限公司共同缔结，本协议对您与长光卫星技术股份有限公司均具有合同效力。<br/>
        1.3 由于互联网高速发展，本协议列明的条款并不能完整罗列并覆盖您与本网站所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，我们将适时修改本协议或进行补充，并在本协议中、本网站中以及我们认为适当的位置发布。您知悉并确认，如您不同意更新后的内容，应立即停止使用本网站；如您继续使用本网站，即视为知悉变动内容并同意接受。<br/>
        1.4 您点击“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。<br/>
        <b>二、用户账号</b><br/>
        2.1 账号注册<br/>
        2.1.1 为了使用本商城服务，用户需要注册一个帐号。您需提供个人真实信息完成帐号注册和密码设置。为使您更好地使用本商城的各项服务，保障您的账户安全，我们可要求您按相关法律法规规定完成实名认证。您有义务保持您提供信息的真实性及有效性。<br/>
        2.1.2 本商城仅面向中华人民共和国公民开放注册。<br/>
        2.1.3 用户注册成功后，我们将给予每个用户一个独立帐号，用户可自行设置或更改帐号密码。帐号和密码由用户负责保管，建议您务必保管好您的账户，如账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，本商城并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。<br/>
        2.1.4 用户应当对其用户帐号进行的所有活动和事件承担法律责任。<br/>
        2.2 账号使用<br/>
        2.2.1 用户不得将注册在自己名下的帐号授予他人使用，授予他人使用的情形包括但不限于用户与他人共享帐号、向他人出借帐号或出售使用权限等。用户也不得使用注册在自己名下的帐号协助他人获得本商城的付费服务。如用户违反本协议的约定，转借帐号或协助盗取的，本商城有权视情况采取冻结帐号、封禁帐号等措施，并保留向该用户追偿的权利。<br/>
        2.3 个人信息保护<br/>
        2.3.1 保护用户个人信息是我们的一项基本原则。我们将会采取合理的措施保护用户的个人信息。我们将按照本协议、《吉林一号生态开放商城隐私政策》的规定收集、使用、存储和分享您的个人信息。除法律法规规定的情形外，未经用户同意，我们不会向第三方公开、披露用户个人信息。我们对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。<br/>
        2.3.2 我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。<br/>
        2.3.3 未经您的同意，我们不会向我们以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。<br/>
        2.3.4 我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应自行或在您的监护人的监护、指导并获得监护人同意的情况下，认真阅读并同意本协议。<br/>
        2.4 账号修改与注销<br/>
        2.4.1 用户在本商城帐号下绑定的手机号或电子邮箱，如因个人原因停止使用，请尽快更改帐号的绑定手机或邮箱，如因未及时换绑手机号导致帐号丢失或个人信息泄露的责任由用户自行承担。<br/>
        2.4.2 用户有权主动注销自己的账号，但注销后我们不退还已收取的任何费用。<br/>
        <b>三、订单与交付</b><br/>
        3.1 使用本商城下订单时，您应具备购买相关商品的权利能力和行为能力。如果您在18周岁以下，您需要在监护人的监护参与下才能注册并使用本网站。在确认下订单的同时，视为您满足上述条件，并对您在订单中提供的所有信息的真实性负责。<br/>
        3.2 在您下订单时，请您仔细确认所购产品价格、数量、型号、规格等信息。<br/>
        3.3 您需理解并同意：本商城上展示的产品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的产品数量、价款及支付方式、收货人、联系方式、合同履行地点、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向本商城发出的合同要约；我们收到您的订单信息后，并将您订单中的商品实际发出时，合同成立。<br/>
        3.4由于市场变化等难以控制因素的影响，本网站无法避免您提交的订单信息中的产品出现价格标示错误等情况。如出现以上情况，您有权取消订单，我们亦有权依法、依约取消订单。若您已经付款，则为您办理退款，并提供订单处理方案。<br/>
        3.5 您在本网站购买的产品将按照本网站指定的交付方式进行交付。<br/>
        <b> 四、用户行为规范</b><br/>
        4.1 本协议依据国家相关法律法规规章制定，您亦同意严格遵守以下义务：<br/>
        4.1.1 从中国大陆向境外传输资料信息时必须符合中国有关法规；<br/>
        4.1.2 不得利用本网站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；<br/>
        4.1.3 不得干扰本网站的正常运转，不得侵入本网站及国家计算机信息系统；<br/>
        4.1.4 不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、不文明的等信息资料；<br/>
        4.1.5 不得教唆他人从事违法违规或本协议、平台规则所禁止的行为；<br/>
        4.1.6 不得利用在本网站注册的账户进行牟利性经营活动；<br/>
        4.1.7 不得发布任何侵犯他人个人信息、著作权、商标权等知识产权或合法权利的内容；<br/>
        4.2 您须对自己在网上的言论和行为承担法律责任，您若在本网站上散布和传播反动、色情或其它违反国家法律的信息，本网站的系统记录有可能作为您违反法律的证据。<br/>
        如果我们有理由认为您的行为违反或可能违反上述约定的，我们可独立进行判断并处理，且在任何时候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。<br/>
        <b>五、法律管辖适用及其他</b><br/>
        1、本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，应向协议签订地有管辖权的人民法院提起诉讼。本协议签订地为中华人民共和国吉林省长春市。<br/>
        2、如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。<br/>
        3、本协议未明示授权的其他权利仍由长光卫星技术股份有限公司保留，您在行使这些权利时须另外取得长光卫星技术股份有限公司的书面许可。长光卫星技术股份有限公司如果未行使前述任何权利，并不构成对该权利的放弃。<br/>
    </div>
</template>

<script>
    export default {
        name: "ServiceAgreement_mobile"
    }
</script>

<style scoped>
    @media only screen and (min-width: 320px){
        html {
            font-size: 62.5% !important;
        }
    }
    @media only screen and (min-width: 640px){
        html {
            font-size: 125% !important;
        }
    }
    @media only screen and (min-width: 750px){
        html {
            font-size: 150% !important;
        }
    }
    @media only screen and (min-width: 1242px){
        html {
            font-size: 187.5% !important;
        }
    }
.policy_content{
    width: 96vw;
    height: auto;
    margin-left: 2vw;
    overflow-wrap: break-word;
    font-size: 1rem;
    line-height: 1.2rem;
}
</style>